import React from 'react';
import { FiCheckCircle, FiClock, FiTrendingUp } from 'react-icons/fi';

type Status = 'strong' | 'average' | 'weak';

interface Props {
  status: Status;
}

const labels: Record<Status, string> = {
  strong: 'Sangat Baik',
  average: 'Cukup Baik',
  weak: 'Perlu Peningkatan',
};

const icons: Record<Status, React.ReactNode> = {
  strong: <FiCheckCircle />,
  average: <FiClock />,
  weak: <FiTrendingUp />,
};

const StatusBadge: React.FC<Props> = ({ status }) => (
  <span className={`iv-badge iv-badge--${status}`}>
    <span className="iv-badge__icon" aria-hidden="true">{icons[status]}</span>
    {labels[status]}
  </span>
);

export default StatusBadge;
